import React from "react";
import { FaShieldAlt, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import Footer from "./Footer";
import "./TermsOfService.css";

const SECTIONS = [
  { id: "intro", label: "Introduction" },
  { id: "collect", label: "Information We Collect" },
  { id: "use", label: "How We Use Your Information" },
  { id: "sharing", label: "Sharing of Information" },
  { id: "cookies", label: "Cookies and Tracking" },
  { id: "security", label: "Data Security" },
  { id: "links", label: "Third-Party Links" },
  { id: "rights", label: "Your Rights and Choices" },
  { id: "children", label: "Children's Privacy" },
  { id: "changes", label: "Changes to This Policy" },
  { id: "contact", label: "Contact Us" },
];

export default function TermsOfService() {
  return (
    <div>
      {/* HERO */}
      <header className="tos-hero">
        <div className="tcc-container tos-hero__inner">
          <span className="tos-hero__badge"><FaShieldAlt aria-hidden="true" /></span>
          <p className="tcc-eyebrow tos-hero__eyebrow">The City Church</p>
          <h1 className="tos-hero__title">Privacy Policy &amp; Terms</h1>
          <p className="tos-hero__lead">
            How we collect, use and safeguard your information when you use our website.
          </p>
          <p className="tos-hero__date">Effective date: 1 March 2025</p>
        </div>
      </header>

      {/* BODY */}
      <section className="tcc-section tos-body">
        <div className="tcc-container tos-body__grid">
          {/* Table of contents */}
          <nav className="tos-toc" aria-label="On this page">
            <p className="tos-toc__title">On this page</p>
            <ol className="tos-toc__list">
              {SECTIONS.map((s) => (
                <li key={s.id}><a href={`#${s.id}`}>{s.label}</a></li>
              ))}
            </ol>
          </nav>

          {/* Content */}
          <article className="tos-content">
            <p className="tos-intro">
              The City Church is committed to protecting your privacy. This Privacy Policy
              explains how we collect, use, disclose and safeguard your information when you
              visit our website{" "}
              <a href="https://thecitychurch.or.ug/" target="_blank" rel="noreferrer">
                thecitychurch.or.ug
              </a>
              . By using our website, you agree to the terms of this Privacy Policy.
            </p>

            <section id="intro" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>1. Introduction</h2>
              <p>
                The City Church is committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, disclose and safeguard your information when you
                visit our website. By using our website, you agree to the terms of this Privacy
                Policy.
              </p>
            </section>

            <section id="collect" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>2. Information We Collect</h2>
              <p>We may collect personal information that you provide directly to us, including but not limited to:</p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Mailing address</li>
                <li>Prayer requests or other submissions</li>
              </ul>
              <p>Additionally, we may automatically collect non-personal information such as:</p>
              <ul>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Operating system</li>
                <li>Website usage data (cookies and analytics)</li>
              </ul>
            </section>

            <section id="use" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>3. How We Use Your Information</h2>
              <ul>
                <li>Communicate with you regarding church events, services and updates</li>
                <li>Respond to inquiries or prayer requests</li>
                <li>Process donations and send contribution receipts</li>
                <li>Improve our website and user experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section id="sharing" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>4. Sharing of Information</h2>
              <p>We do not sell, rent or trade your personal information. However, we may share your information in the following circumstances:</p>
              <ul>
                <li>With trusted third-party service providers who assist us in website operations, digital payments or communications</li>
                <li>As mandated by law or to protect legal rights</li>
                <li>With your consent in line with the Data Privacy and Protection Act 2019</li>
              </ul>
            </section>

            <section id="cookies" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>5. Cookies and Tracking Technologies</h2>
              <p>
                Our website may use cookies and similar tracking technologies to enhance your
                browsing experience. You can set your browser to refuse cookies or alert you when
                cookies are being sent.
              </p>
            </section>

            <section id="security" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>6. Data Security</h2>
              <p>
                We implement reasonable security measures to protect your information from
                unauthorized access or disclosure. However, no method of transmission over the
                internet is 100% secure.
              </p>
            </section>

            <section id="links" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>7. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are not responsible for
                the privacy practices of these external sites.
              </p>
            </section>

            <section id="rights" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>8. Your Rights and Choices</h2>
              <ul>
                <li>Access, update or delete your personal information</li>
                <li>Opt out of communications</li>
                <li>Request details about data usage</li>
              </ul>
              <p>
                To exercise these rights, contact us at{" "}
                <a href="mailto:info@thecitychurch.or.ug">info@thecitychurch.or.ug</a>.
              </p>
            </section>

            <section id="children" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>9. Children&rsquo;s Privacy</h2>
              <p>
                Our website is not directed toward children under the age of 18. We do not
                knowingly collect personal information from children. This website strives to be in
                complete adherence to Uganda&rsquo;s Data Privacy and Protection Act 2019.
              </p>
            </section>

            <section id="changes" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>10. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Changes will be posted on this
                page with an updated effective date.
              </p>
            </section>

            <section id="contact" className="tos-section" style={{ scrollMarginTop: "90px" }}>
              <h2>11. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at:</p>
              <div className="tos-contact">
                <p className="tos-contact__name">The City Church</p>
                <ul className="tos-contact__list">
                  <li><FaMapMarkerAlt aria-hidden="true" /> Kitintale-Luzira, Kampala</li>
                  <li><FaEnvelope aria-hidden="true" /> <a href="mailto:info@thecitychurch.or.ug">info@thecitychurch.or.ug</a></li>
                  <li><FaPhoneAlt aria-hidden="true" /> <a href="tel:+256706332572">+256 706 332572</a></li>
                </ul>
              </div>
            </section>
          </article>
        </div>
      </section>

      <Footer />
    </div>
  );
}
